import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "chunk-reload-at";

/**
 * Wraps React.lazy so that a stale/failed chunk fetch (common right after a
 * new deploy invalidates old asset hashes) retries once, then force-reloads
 * the page a single time instead of showing a blank screen.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (err) {
      // Second chance: transient network hiccup
      try {
        await new Promise((r) => setTimeout(r, 400));
        return await factory();
      } catch (err2) {
        const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
        if (Date.now() - last > 10000) {
          sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
          window.location.reload();
          // Never resolves; page is reloading.
          return await new Promise<{ default: T }>(() => {});
        }
        throw err2;
      }
    }
  });
}
